/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useState, useCallback, useContext } from "react";
import { useFormik } from "formik";
import { handleRecorderById, handleConfirmRecorder } from "api/timeRecorder";
import useToastNotification from "hooks/useToastNotification";
import ConfirmRecorderByBarcodeIdDomain from "domain/timeRecorder/confirmRecorderByBarcodeIdDomain";
import RecorderByBarcodeIdDomain from "domain/timeRecorder/recorderByBarcodeIdDomain";

import InfoStaffTimeRecorderDomain from "domain/timeRecorder/infoStaffTimeRecorderDomain";
import { CurrentTimeDomain } from "domain/master/attend/currentTime";
import { TimeRecorderContext } from "components/organismos/Recorder/Recorder";

const LOCAL_STORAGE_SHOP_INFO_KEY_NAME = "win-board-localstorage-shop-info";

const { errorNotification, successNotification } = useToastNotification();

export const useBarcodeRecorder = (
  stampOrgCode: string,
  setStampOrgCode: any,
  stampOrgName: string,
  setStampOrgName: any,
  loginOrgCode: string,
  setLoginOrgCode: any,
  loginOrgName: string,
  setLoginOrgName: any,
  resultCurrentTime: CurrentTimeDomain,
  setOpenModal: any,
  setIsLoading: any,
  fetchHistoryData: any
) => {
  // get local storage
  const contextObject = useContext(TimeRecorderContext);  
  const {companyCode, shopCode, stampByBelongOrg} = contextObject;

  const [isConfirm, setIsConfirm] = useState(false);

  //Use New UI Remote
  const [newUiRemote, setNewUiRemote] = useState<boolean>(false);
  const [isRemote, setIsRemote] = useState<boolean>(false);

  // ID
  const [inputBarcodeId, setInputBarcodeId] = useState("");
  const [barcodeId, setBarcodeId] = useState("");

  // Staff
  const [stampMode, setStampMode] = useState(0);
  const [staffName, setStaffName] = useState("");

  // type
  const [lastStampType, setLastStampType] = useState<any>();
  const [stampType, setStampType] = useState<any>();

  
  const [businessList, setBusinessList] = useState<any>();
  const [businessName, setBusinessName] = useState("")

  const onSubmit = async (values: ConfirmRecorderByBarcodeIdDomain) => {
    setIsLoading(true);
    try {
      await handleRecorderById(shopCode, companyCode, values.getRawData()).then(
        (response: InfoStaffTimeRecorderDomain) => {
          setIsConfirm(true);
          const stampStaffData = response.stampStaffList[0];
          setLastStampType(stampStaffData.lastStampType);
          setBusinessCnt(stampStaffData.businessList.length);
          setBusinessList(stampStaffData.businessList);
          setStaffName(stampStaffData.staffName);
          setStaffCode(stampStaffData.staffCode);
          setBarcodeId(stampStaffData.barcodeId);
          setStampOrgCode(stampStaffData.orgCode);
          setStampOrgName(stampStaffData.orgName);
          setNewUiRemote(stampStaffData.useRemote);
          setIsRemote(stampStaffData.isRemote);
          setIsLoading(false);
        }
      );
    } catch (error) {
      setIsLoading(false);
      if (error.response.data.message) {
        errorNotification(error.response.data.message);
        return;
      }
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        let stringErr = "";
        listErr.map((element: any) => {
          stringErr += `${element.defaultMessage} \n`;
          return stringErr;
        });
        errorNotification(stringErr);
      } else {
        errorNotification("サーバー側でエラーが発生しました。");
        throw error;
      }
    }
  };

  const formik = useFormik({
    initialValues: ConfirmRecorderByBarcodeIdDomain.generateInitial(),
    onSubmit,
  });
  const handleSubmitBarcode = useCallback(() => {
    setIsLoading(true);
    setStampMode(3);
    formik.setFieldValue("stampMode", stampMode);
    formik.setFieldValue("stampByBelongOrg", stampByBelongOrg);
    formik.setFieldValue("orgName", stampOrgName);
    formik.setFieldValue("orgCode", stampOrgCode);
    formik.setFieldValue("loginOrgName", loginOrgName);
    formik.setFieldValue("loginOrgCode", loginOrgCode);
    formik.setFieldValue("staffName", staffName);
    formik.setFieldValue("barcodeId", barcodeId);
    formik.setFieldValue("stampTime", String(resultCurrentTime.serverDateTime));
    formik.submitForm();
  }, [
    barcodeId,
    formik,
    loginOrgCode,
    loginOrgName,
    resultCurrentTime.serverDateTime,
    staffName,
    stampByBelongOrg,
    stampMode,
    stampOrgCode,
    stampOrgName,
  ]);

  const [,setStaffCode] = useState("");
  const [businessCnt, setBusinessCnt] = useState(0);
  //submit
  const handleRecorder = useCallback(
    (stampType: number, businessId?: string, businessName?: string, flagRemote?: boolean) => {
      if(flagRemote){
        formikConfirm.setFieldValue("isRemote", true);  
      }else{
        formikConfirm.setFieldValue("isRemote", isRemote);  
      }
      setBusinessName(businessName||"");
      setStampType(stampType);
      formikConfirm.setFieldValue("orgCode", stampOrgCode);
      formikConfirm.setFieldValue("orgName", stampOrgName);
      formikConfirm.setFieldValue("loginOrgName", loginOrgName);
      formikConfirm.setFieldValue("loginOrgCode", loginOrgCode);
      formikConfirm.setFieldValue("staffName", staffName);
      formikConfirm.setFieldValue("barcodeId", barcodeId);
      formikConfirm.setFieldValue("inputBarcodeId", inputBarcodeId);
      formikConfirm.setFieldValue(
        "stampTime",
        String(resultCurrentTime.serverDateTime)
      );
      formikConfirm.setFieldValue("stampType", stampType);
      formikConfirm.setFieldValue("businessId", businessId);
      formikConfirm.setFieldValue("stampMode", stampMode);
      formikConfirm.submitForm();
      setOpenModal(true);
    },
    [
      barcodeId,
      inputBarcodeId,
      loginOrgCode,
      loginOrgName,
      resultCurrentTime.serverDateTime,
      staffName,
      stampMode,
      stampOrgCode,
      stampOrgName,
    ]
  );

  const onSubmitConfirm = async (values: RecorderByBarcodeIdDomain) => {
    setIsLoading(true);
    handleConfirmRecorder(shopCode, companyCode, values.getRawData()).then(
      (response: any) => {
        successNotification(
          response.stampResultInfo.replace("<h4>", "").replace("</h4>", "")
        );
        setIsConfirm(false);
        fetchHistoryData();
        formik.resetForm();
        formikConfirm.resetForm();
        setInputBarcodeId("");
        setOpenModal(false);
        setIsLoading(false);
      }
    ).catch((error: any) => {
      setIsLoading(false);
      setIsConfirm(false);
      setOpenModal(false);
      if (error.response.status === 400) {
        if (error.response.data.errors && error.response.data.errors.length > 0) {
          errorNotification(
            error.response.data.errors.map((x: any) => x.defaultMessage)
          );
        } else if (error.response.data.defaultMessage) {
          errorNotification(error.response.data.defaultMessage);
        } else {
          errorNotification(error.response.data.message);
        }
      } else {
        errorNotification("サーバー側でエラーが発生しました。");
      }
    });
  };

  const formikConfirm = useFormik({
    initialValues: RecorderByBarcodeIdDomain.generateInitial(),
    onSubmit: (values) => {
      onSubmitConfirm(values);
    },
  });

  return {
    handleSubmitBarcode,
    formik,
    businessList,
    lastStampType,
    setIsConfirm,
    isConfirm,
    staffName,
    businessCnt,
    formikConfirm,
    handleRecorder,
    stampOrgCode,
    businessName,
    stampType,
    newUiRemote
  };
};
export default useBarcodeRecorder;
